import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { BrComService } from '../../service/BrComService';

@Component({
  selector: 'page-navegador',
  templateUrl: 'navegador.html',
})
export class NavegadorPage {
  public urlSanatized: SafeResourceUrl;
  public url: string;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private domSanitizer: DomSanitizer, public brComService: BrComService) {
    this.url = navParams.get('url');
    this.urlSanatized = this.domSanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  public abrirPaginaNoNavegador(): void {
    this.brComService.abrePaginaNoBrowser(this.url);
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/navegador/navegador.ts